import type {
  loan_quote_presentation,
  loan_application,
} from '@axo/shared/data-access/types';
import type { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';
import { createResourceRequest } from '../api-crud.factory';

export function getProductRecommendation({
  url: { integration: baseURL },
  token,
}: IAPI) {
  if (!baseURL)
    throw new Error(
      'No integration URL found! Configure integration URL with <DataAccessContext.Provider>'
    );
  return async (
    applicationID?: string
  ): Promise<loan_quote_presentation.ProductRecommendationResponse> =>
    send({
      baseURL,
      token,
      method: 'GET',
      path: `/loan-quote-presentation/product-recommendation/loan-application/${applicationID}/latest`,
    });
}

/**
 * Reapply for a recommendation with a specific product.
 * Clones the loan application using the provided product recommendation product
 * and channels and links it back to the chosen recommendation.
 *
 * @see /product-recommendation/loan-application/{applicationID}/reapply
 */
export const postProductRecommendationReapply = createResourceRequest<
  loan_quote_presentation.ReapplyForRecommendationRequest,
  loan_application.LoanApplication,
  { applicationId: string }
>(
  '/loan-quote-presentation/product-recommendation/loan-application/:applicationId/reapply',
  'integration'
);
